module.exports = __webpack_public_path__ + "fonts/fa-solid-900.e245d7d6.woff2";